import axios from "axios";
import { refreshTokenIvideon } from "~/services/ivideon/lib/refreshToken";
import {
  destroyIvideonCredentials,
  setIvideonCredentials,
} from "~/services/ivideon/lib/tokenWorkers";

interface IGetConfiguredAxiosInstance {
  baseURL: string;
  access_token: string;
  refresh_token: string;
  api4_host: string;
  api_host: string;
  expires_in: number;
  toggleIvideonIsAuth: (bool: boolean) => void;
  id?: string;
}

/**
 * Конфигурация AXIOS для IVIDEON
 * @param baseURL - базовое направление запроса
 * @param access_token - токен доступа
 * @param refresh_token - токен обновления токена доступа
 * @param toggleIvideonIsAuth - функция изменения состояния авторизации для отображения в компоненте
 */
export const getConfiguredAxiosInstance = ({
  baseURL,
  access_token,
  refresh_token,
  toggleIvideonIsAuth,
  id,
}: IGetConfiguredAxiosInstance) => {
  const axiosInstance = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

  /**
   * Функция перехватчик запроса
   *
   * Если получаем ошибку от бэка связанную с авторизацией,
   * пытаемся обновить токен и повторить предыдущий запрос
   */
  function createAxiosResponseInterceptor() {
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Если обычная ошибка (не связана с авторизацией), возврощаем ее
        if (error.response?.status !== 401) {
          return Promise.reject(error);
        }

        axiosInstance.interceptors.response.eject(interceptor);

        return refreshTokenIvideon({ refresh_token })
          .then((response) => {
            if (typeof response !== "string") {
              // если все гуд и обновление токена удачно, сетим новые данные в куки и обновляем инстанс AXIOS
              const {
                access_token,
                api_host,
                refresh_token,
                expires_in,
                api4_host,
              } = response;
              if (access_token && api_host && refresh_token) {
                setIvideonCredentials({
                  open_api_host: api_host,
                  access_token,
                  expires: expires_in,
                  api_host: api4_host,
                  DealerId: id,
                });
                toggleIvideonIsAuth && toggleIvideonIsAuth(true);

                error.response.config.headers["Authorization"] =
                  "Bearer " + response.access_token;

                error.response.config.baseURL = `https://${api_host}`;

                return axios(error.response.config);
              }
            } else {
              destroyIvideonCredentials();
              toggleIvideonIsAuth && toggleIvideonIsAuth(false);
            }
          })
          .catch((error2) => {
            destroyIvideonCredentials();
            toggleIvideonIsAuth && toggleIvideonIsAuth(false);

            return Promise.reject(error2);
          })
          .finally(createAxiosResponseInterceptor);
      }
    );
  }

  createAxiosResponseInterceptor();
  return axiosInstance;
};
